import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import Loader from "@/components/loader";
import { fetchMilestone } from "@/modules/work/milestones/api";

const MilestoneContext = createContext(null);

export const MilestoneProvider = ({ children }) => {
  const { milestoneId } = useParams();

  const { data, isLoading, isError, error, refetch } = useFetch({
    queryKey: ["milestone", milestoneId],
    queryFn: () => fetchMilestone({ milestoneId }),
    enabled: !!milestoneId,
  });

  if (isLoading) return <Loader />;
  if (isError)
    return (
      <div className="p-4 text-red-600">
        {error?.message || "Error loading milestone"}
      </div>
    );

  const value = {
    milestoneId,
    milestone: data,
    job: data?.job,
    jobId: data?.job?.id,
    project: data?.job?.project,
    projectId: data?.job?.project?.id,
    type: data?.job?.type,
    jobType: data?.job?.type,
    refetch,
  };

  return (
    <MilestoneContext.Provider value={value}>
      {children}
    </MilestoneContext.Provider>
  );
};

export const useMilestone = () => {
  const ctx = useContext(MilestoneContext);
  if (!ctx) {
    throw new Error("useMilestone must be used within a MilestoneProvider");
  }
  return ctx;
};
